import { render, staticRenderFns } from "./SelfInfo.vue?vue&type=template&id=28d1d49a&scoped=true"
import script from "./SelfInfo.vue?vue&type=script&lang=ts"
export * from "./SelfInfo.vue?vue&type=script&lang=ts"
import style0 from "./SelfInfo.vue?vue&type=style&index=0&id=28d1d49a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1d49a",
  null
  
)

export default component.exports